import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局注册baseURL
import global_ from "./utils/config";

// 懒加载插件
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload)

// baseURL
Vue.prototype.GLOBAL = global_;
Vue.use(ElementUI);

Vue.config.productionTip = false

import BUTTOM from "./components/buttom.vue";
Vue.component("BUTTOM",BUTTOM);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 跳转后自动返回页面顶部
router.afterEach(() => {
  window.scrollTo(0,0);
})

Vue.use(VueLazyload, {
  preLoad: 1.3, // 预加载的高度比例
  error: 'path-to-error-image', // 加载失败时显示的图片
  loading: 'path-to-loading-image', // 加载过程中显示的图片
  attempt: 1 // 尝试加载次数
})